import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import ServicesHeroBanner from "../components/ServicesHeroBanner";
import MultpleCard from "../components/Multple-card";
import ServicesProcess from "../components/ServicesProcess";
import Choose from "../components/Choose";
import ContactForm from "../components/contact-form";
import Blog from "../components/Blog";

import servicesHeaderImage from "../images/comp/services-header-image-7.webp";
import diverseImage from "../images/comp/choose_zoho_img.webp";
import researchIcon from "../images/research-icon.png";
import planningIcon from "../images/Planning.png";
import designIcon from "../images/Design.png";
import ux_icon from "../images/ux_icon.png";
import supportIcon from "../images/Support.png";
import developmentIcon from "../images/development.png";
import qualityIcon from "../images/Quality.png";
import testingIcon from "../images/Testing.png";

const ZohoservicesPage = () => {
  const heroBannerData = {
    subtitle: "Zoho Solutions",
    title: "Zoho That Fits. Zoho That Grows.",
    description:
      "At Hope Web Solutions, we help businesses streamline operations and boost productivity with customized Zoho solutions. From CRM to finance, email, and automation tools—we implement, integrate, and optimize Zoho products to suit your unique business processes and goals.",
    buttonText: "Contact now",
    buttonLink: "#contact",
    img: servicesHeaderImage,
  };
  const cardsData = [
    {
      title: "Zoho CRM Setup & Customization",
      description:
        "Setting up Zoho CRM with tailored modules, workflows, and integrations to align with your sales, marketing, and support processes.",
      icon: researchIcon,
    },
    {
      title: "Zoho One Implementation",
      description:
        "Deploying Zoho One—our all-in-one business management suite—to unify your sales, marketing, finance, and HR operations for streamlined efficiency.",
      icon: planningIcon,
    },
    {
      title: "Zoho Creator (Custom App Development)",
      description:
        "Developing custom apps using Zoho Creator to automate workflows, enhance data management, and improve productivity with tailored solutions.",
      icon: designIcon,
    },
    {
      title: "Zoho Books & Finance Suite",
      description:
        "Integrating Zoho Books with your existing accounting system to automate invoicing, expense tracking, and financial reporting for better visibility and control.",
      icon: developmentIcon,
    },
    {
      title: "Zoho Mail & Workplace",
      description:
        "Setting up Zoho Mail for secure email communication and Zoho Workplace for team collaboration, knowledge sharing, and productivity tools.",
      icon: testingIcon,
    },
    {
      title: "Third-Party Integrations",
      description:
        "Connecting Zoho apps with platforms like Shopify, WordPress, WhatsApp, and more for streamlined operations.",
      icon: qualityIcon,
    },
  ];

  const processData = [
    {
      title: "Consultation & Requirement Gathering",
      description:
        "Identifying your business processes, pain points, and specific Zoho needs to create a tailored implementation plan.",
      icon: researchIcon,
    },
    {
      title: "Account Setup & Configuration",
      description:
        "Setting up Zoho One modules, configuring email accounts, and integrating with your existing systems for seamless operation.",
      icon: designIcon,
    },
    {
      title: "Customization & Development",
      description:
        "Tailoring dashboards, reports, and automation rules to enhance productivity.",
      icon: ux_icon,
    },
    {
      title: "Data Migration",
      description:
        "Securely importing existing contacts, leads, inventory, or financial data into Zoho systems.",
      icon: developmentIcon,
    },
    {
      title: "Integration & Testing",
      description:
        "Connecting Zoho with third-party tools and testing every module for accuracy and performance.",
      icon: testingIcon,
    },
    {
      title: "Training & Support",
      description:
        "Training your team and providing ongoing technical support, updates, and optimizations.",
      icon: supportIcon,
    },
  ];

  const chooseData = {
    title: "Why Choose Hope Web Solutions?",
    image: diverseImage,
    imageAlt: "Team",
    items: [
      {
        label: "Planning",
        text: "Hope Web Solutions is a leading Web and Mobile App Development company, delivering cutting-edge digital solutions.",
      },
      {
        label: "Our Mission",
        text: "Our mission is to empower businesses with exceptional digital solutions that drive growth, enhance user experience.",
      },
      {
        label: "Our Vision",
        text: "Our vision is to be a global leader in web and mobile app development, recognized for our innovation, quality, and customer satisfaction.",
      },
    ],
    buttonText: "Contact now",
    buttonLink: "/contact",
  };
  return (
    <div>
      <Header />
      <ServicesHeroBanner {...heroBannerData} />
      <section className="planning-section-services">
        <div className="container">
          <div className="row align-items-center justify-content-center">
            <div className="col-lg-8 mb-4 mb-lg-0 position-relative text-center">
              <h2 className="title">Zoho Services</h2>
              <p className="sub-title text-black pt-2">
                We provide expert Zoho consulting, implementation, and support
                services to empower your business with seamless workflows and
                smarter management tools.
              </p>
            </div>
          </div>
          <div className="process-grid mt-3">
            {/* 👉 Cards Loop */}
            {cardsData.map((item, index) => (
              <MultpleCard
                key={index}
                title={item.title}
                description={item.description}
                icon={item.icon}
              />
            ))}
          </div>
        </div>
      </section>
      <ServicesProcess
        title="Zoho Implementation Process"
        subtitle="Our structured implementation process ensures your Zoho journey is smooth, efficient, and tailored to your business needs."
        processData={processData}
      />
      <Choose {...chooseData} />
      <ContactForm />
      <Blog />
      <Footer />
    </div>
  );
};

export default ZohoservicesPage;
